import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddCompany({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer 
    pageName={'Add Company'}  
    email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />
    )
}

